


























import { SPOT_HEALTH_META } from '@/features/domain-ui/spot-health/constants';
import { Point } from '@/features/ui/charts/stacked-horizontal-chart/model';
import { SpotHealth } from '@/types/iot-portal';
import { BooleanProp, ObjectProp } from '@/util/prop-decorators';
import { Component, Vue } from 'vue-property-decorator';
import { DomainUiSpotSummaryPanelCollectionFragment } from './__generated__/DomainUiSpotSummaryPanelCollectionFragment';

const spotHealths = [SpotHealth.CRITICAL, SpotHealth.DEGRADED, SpotHealth.OK, SpotHealth.UNKNOWN, SpotHealth.INACTIVE];

type HealthState = { health: SpotHealth; count: number };

@Component
export default class SpotSummaryContent extends Vue {
  @ObjectProp(true)
  private readonly collection!: DomainUiSpotSummaryPanelCollectionFragment;

  @BooleanProp()
  private readonly detailsLink!: boolean;

  @BooleanProp()
  private readonly loading!: boolean;

  private get healthStates(): HealthState[] {
    const stateMap = new Map(this.collection.healthAggregations.map(({ health, count }) => [health, count]));

    return spotHealths.map((health) => ({ health, count: stateMap.get(health) ?? 0 }));
  }

  private get chartPoints(): Point[] {
    return this.healthStates.map(({ count, health }) => ({ value: count, color: SPOT_HEALTH_META[health].color }));
  }
}
